/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_hplc_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`With the ratio of internal diameters squared, and inversely with particle size, so the linear velocity through the packing stays constant.`)
};

const es_hplc_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Con la razón de diámetros internos al cuadrado, y de forma inversa con el tamaño de partícula, para que la velocidad lineal a través del empaque se mantenga constante.`)
};

const de_hplc_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mit dem Verhältnis der Innendurchmesser im Quadrat und umgekehrt proportional zur Partikelgröße, damit die lineare Geschwindigkeit durch das Packungsmaterial konstant bleibt.`)
};

const nl_hplc_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Met de verhouding van de inwendige diameters in het kwadraat, en omgekeerd evenredig met de deeltjesgrootte, zodat de lineaire snelheid door de pakking constant blijft.`)
};

const fr_hplc_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selon le rapport des diamètres internes au carré, et inversement à la taille des particules, afin que la vitesse linéaire à travers le remplissage reste constante.`)
};

const it_hplc_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Con il rapporto dei diametri interni al quadrato, e in modo inverso con la dimensione delle particelle, così la velocità lineare attraverso il riempimento resta costante.`)
};

const pt_br2_hplc_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Com a razão dos diâmetros internos ao quadrado, e inversamente com o tamanho de partícula, para que a velocidade linear pelo recheio permaneça constante.`)
};

const pt_hplc_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Com o quadrado da razão entre diâmetros internos, e inversamente com o tamanho da partícula, para que a velocidade linear através do enchimento se mantenha constante.`)
};

const ja_hplc_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`内径の比の2乗に比例し、粒子径に反比例することで、充填剤内の線速度が一定に保たれます。`)
};

const zh_hplc_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`按内径比的平方变化，并与粒径成反比，从而使填料内的线速度保持恒定。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const hplc_faq_a2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.hplc_faq_a2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("hplc_faq_a2", locale)
	if (locale === "en") return en_hplc_faq_a2(inputs)
	if (locale === "es") return es_hplc_faq_a2(inputs)
	if (locale === "de") return de_hplc_faq_a2(inputs)
	if (locale === "nl") return nl_hplc_faq_a2(inputs)
	if (locale === "fr") return fr_hplc_faq_a2(inputs)
	if (locale === "it") return it_hplc_faq_a2(inputs)
	if (locale === "pt-BR") return pt_br2_hplc_faq_a2(inputs)
	if (locale === "pt") return pt_hplc_faq_a2(inputs)
	if (locale === "ja") return ja_hplc_faq_a2(inputs)
	return zh_hplc_faq_a2(inputs)
};